<div class="overflow-y-auto height-without-bar lg:h-full">
  @if (isLoading()) {
    <div class="w-full h-full flex justify-center items-center">
      <div class="spinner-border custom-big-spinner border-white" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  }

  <div class="mt-6 lg:mt-40 pb-12 lg:pb-20">
    <div class="container px-[0.75rem] mx-auto">
      <!-- Risultati caricati -->
      @if (isLoading()) {
        <div
          class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-[12px] gap-y-6 lg:gap-x-6 lg:gap-y-10">
          @for (skeleton of skeletons(); track $index) {
            <app-placeholder-card></app-placeholder-card>
          }
        </div>
      } @else {
        @if (hasFavorites()) {
          <div
            class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-[12px] gap-y-6 lg:gap-x-6 lg:gap-y-10"
            infiniteScroll>
            @for (item of favorites(); track item.id) {
              <app-preview-item-card [xploreItem]="item" class=""></app-preview-item-card>
            }
          </div>
        }
        @if (!hasFavorites()) {
          <div
            class="flex flex-col justify-center items-center h-[calc(100vh-350px)] text-center">
            <!-- Nessun preferito -->
            <h2 class="font-semibold text-2xl md:text-3xl my-6">{{ 'favorites_page.no_favorites' | translate }}</h2>
            <span class="text-sm md:text-base">
              {{ 'favorites_page.no_favorites_text' | translate }}
            </span>
          </div>
        }
      }

    </div>
  </div>
</div>
